import { useMutation } from 'Data/Api.js'
import { useDataValue } from 'Simple/Data'
import {
  useNotifications,
  notifyError,
  notifySuccess,
} from 'Logic/Notifications'

import mutationTriggerSyncPatients from './triggerSyncMutation.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let [, executeTriggerSyncPatientsMutation] = useMutation(
    mutationTriggerSyncPatients
  )
  let [, notify] = useNotifications()

  let location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location._id',
  })

  return async function onSubmit({ value, originalValue, args, change }) {
    switch (args.type) {
      case 'manage': {
        change(next => {
          next.selected.app_id = args.app_id
        })
        return
      }

      case 'back/apps': {
        change(next => {
          next.selected.app_id = null
        })
        return
      }

      case 'back/app': {
        change(next => {
          next.selected.automation_id = null
          next.selected.sync_id = null
          next.selected.sync_is_matching = false
        })
        return
      }

      case 'edit_automation': {
        change(next => {
          next.selected.automation_id = args.id
        })
        return
      }

      case 'sync': {
        let mutationResponse = await executeTriggerSyncPatientsMutation({
          connection_id: args.connection_id,
          location_id,
        })
        if (mutationResponse.error) {
          notify(notifyError('Something went wrong. Please try again later.'))
          return
        }

        notify(
          notifySuccess(
            'App records compared with Greyfinch will show once the sync is complete. Please wait a few moments until sync is complete.',
            'Sync in progress'
          )
        )

        change(next => {
          next.selected.sync_id =
            mutationResponse.data.apps_sync_processing_start.sync_id
        })

        break
      }

      case 'open_sync': {
        change(next => {
          next.selected.sync_id = args.sync_id
        })
        break
      }

      default: {
        return
      }
    }
  }
}
